<mib-header [endRule]="false" [middleFills]="fillsBar()">
  <ng-template #logos>
    <svg mib-logo-medinbox class="h-7 text-mib-branding-900 compact:hidden"></svg>
    <svg mib-logo-symbol class="hidden text-mib-branding-900 compact:block"></svg>
  </ng-template>

  @if (permissions.canGoBack()) {
    <a
      mibHeaderBrand
      mibBareButton
      class="not-expanded:mr-1"
      routerLink="/"
      aria-label="Medinbox home">
      <ng-container [ngTemplateOutlet]="logos"></ng-container>
    </a>
  } @else {
    <span
      mibHeaderBrand
      class="not-expanded:mr-1 flex items-center"
      role="img"
      aria-label="Medinbox">
      <ng-container [ngTemplateOutlet]="logos"></ng-container>
    </span>
  }

  <!-- The way between the library and the cases held open, above every page rather than inside one. -->
  @if (!fillsBar() && permissions.canOpenLibrary()) {
    <mai-case-tabs class="self-stretch"></mai-case-tabs>
  }

  <!-- The page's middle, at its content's width and padded left so the tabs never touch the actions. -->
  <span
    class="flex items-center gap-2 not-expanded:gap-1"
    [class]="
      fillsBar()
        ? 'min-w-0 flex-1'
        : 'flex-1 basis-auto shrink-0 pl-4 not-expanded:basis-0 not-expanded:shrink'
    "
    [class.not-expanded:pl-3]="!slot.middle()"
    [class.justify-end]="!permissions.canOpenLibrary()">
    @if (slot.middle(); as middle) {
      <ng-container [ngTemplateOutlet]="middle.template"></ng-container>
    }
  </span>

  <span mibHeaderEnd [class.not-expanded:pl-3]="slot.middle()">
    <!-- The page's end replaces the identity, never both: a room display has no account to show. -->
    @if (slot.end(); as end) {
      <ng-container [ngTemplateOutlet]="end.template"></ng-container>
    } @else {
      <!-- The identity shows once: in the bar when there is room, in the panel otherwise. -->
      <button
        mibBareButton
        [mibMenuTrigger]="accountMenu"
        [attr.aria-label]="'Account of ' + (mainMenu.username() ?? 'guest')">
        <mib-avatar
          size="sm"
          [username]="mainMenu.username()"
          [withName]="nameInBar()"
          [nameFirst]="nameInBar()"></mib-avatar>
      </button>

      <mib-menu
        #accountMenu
        align="end"
        [menuItems]="mainMenu.entries()"
        (itemSelected)="mainMenu.onItemSelected($event)">
        @if (!nameInBar()) {
          <mib-avatar
            mibMenuHeader
            class="w-full"
            size="md"
            withName
            [username]="mainMenu.username()"></mib-avatar>
        }
      </mib-menu>

      <mai-main-menu #mainMenu></mai-main-menu>
    }
  </span>
</mib-header>
